import Axios from "axios";

// sign-up.js
;(( { $$, log }) => {
    const inputWrapperErrorClass = 'control-wrapper--error'

    $$('.form-sign-in').forEach(form => {
        form.addEventListener('submit', e => e.preventDefault())

        const url = form.dataset.url
        const emailInput = form.querySelector(`[name="email"]`)
        const passwordInput = form.querySelector(`[name="password"]`)
        const submitButton = form.querySelector(`[type="submit"]`)
        let requestInProcess = false        

        if (!url || !emailInput || !passwordInput || !submitButton) {
            return
        }

        submitButton.addEventListener('click', e => {
            e.preventDefault()

            if (submitButton.classList.contains('button--disabled')) {
                return
            }

            if (requestInProcess) {
                return
            }

            const email = emailInput.value
            const password = passwordInput.value

            makeRequest(email, password)
        })

        async function makeRequest(email, password) {
            requestInProcess = true
            
            try {
                const result = await Axios.post(url, {email, password})
                
                if (result.status === 200) {
                    const link = result?.data?.url
                    if (link) {
                        form.reset()
                        window.location.href = link
                    }
                }
                
                requestInProcess = false
            } catch (e) {
                // log(e.response)
                if (e.response.status === 422) {
                    handleUprocessableData(e.response.data.errors)
                }

                requestInProcess = false
            }
        }

        function handleUprocessableData(errors) {
            for (const [key, value] of Object.entries(errors)) {
                addErrorToInput(key, value)
            }
        }

        function addErrorToInput(inputName, errorMsg) {
            const input = form.querySelector(`[name="${inputName}"]`)
            if (!input) return

            const wrapper = input.closest('.control-wrapper')
            if (!wrapper) return

            const errorMsgEl = wrapper.querySelector('.control-wrapper__error-msg')
            if (!errorMsg) return

            wrapper.classList.add(inputWrapperErrorClass)
            errorMsgEl.innerText = errorMsg
        }
    })
})(CNS);
